// extracted by mini-css-extract-plugin
export default {"colorChip":"chips_colorChip__EkNPn","textChip":"chips_textChip__D7Fp4","roundChip":"chips_roundChip__Ka3P0"};